import { passwordScore } from "@/lib/api";

const LABELS = ["Too weak", "Weak", "Fair", "Good", "Strong"];
const COLORS = ["bg-rose-400", "bg-rose-400", "bg-amber-400", "bg-blue-500", "bg-emerald-500"];

/** Live password strength feedback. Server enforces the same rule. */
export const PasswordMeter = ({ value }) => {
  const { score, reason } = passwordScore(value);
  if (!value) return <p className="mt-2 text-xs text-slate-400">At least 8 characters, with a number or symbol.</p>;
  return (
    <div className="mt-2" data-testid="password-meter">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`h-1 flex-1 rounded-full ${i < score ? COLORS[score] : "bg-slate-200"}`} />
        ))}
      </div>
      <p className="mt-1.5 text-xs text-slate-500" data-testid="password-strength-label">
        <span className="font-semibold">{LABELS[score]}</span>
        {reason ? ` — ${reason}` : " — good to go"}
      </p>
    </div>
  );
};
